import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { sortedPages } from './selectors';
export const reindexDisplayOrders = (pages)=>pages.map((page, index)=>_object_spread_props(_object_spread({}, page), {
            displayOrder: index
        }));
export const reorderVisibleKeepingHidden = (allPages, reorderedVisibleIds, hiddenPageIds)=>{
    const visibleById = new Map(allPages.filter((p)=>!hiddenPageIds.has(p.id)).map((p)=>[
            p.id,
            p
        ]));
    const reorderedVisible = reorderedVisibleIds.map((id)=>visibleById.get(id)).filter((p)=>p != null);
    const hidden = sortedPages(allPages.filter((p)=>hiddenPageIds.has(p.id)));
    return reindexDisplayOrders([
        ...reorderedVisible,
        ...hidden
    ]);
};
